// extracted by mini-css-extract-plugin
export var btnContainer = "Section_btnContainer__uBRO-";
export var cancel = "Section_cancel__EkQ3N";
export var editContainer = "Section_editContainer__hnQBs";
export var header = "Section_header__DxUz+";
export var headerLeft = "Section_headerLeft__q5Qfn";
export var hiddenContainer = "Section_hiddenContainer__0wmP0";
export var lg = "992px";
export var md = "768px";
export var personalForm = "Section_personalForm__Vbfxq";
export var readOnlyContainer = "Section_readOnlyContainer__1vdJb";
export var save = "Section_save__eUjCY";
export var shared = "\"../shared.module.css\"";